(function () {
  "use strict";
  var doc = document;
  var SEL = "[data-xg-film],[data-xg-film-img]";
  var STATE = "data-xg-film-state";
  var QUERY = "(prefers-reduced-motion: reduce)";
  function mq() {
    return typeof window.matchMedia === "function"
      ? window.matchMedia(QUERY)
      : null;
  }
  function reduced() {
    var m = mq();
    return !!(m && m.matches);
  }
  function thrifty() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return false;
    if (c.saveData) return true;
    var t = c.effectiveType || "";
    return t === "slow-2g" || t === "2g";
  }
  function attr(el, name) {
    var v = el.getAttribute(name);
    return v && v.length ? v : null;
  }
  function candidates(el) {
    var media = attr(el, "data-xg-film-media");
    var narrow = attr(el, "data-xg-film-size-narrow");
    var out = [];
    function push(url, type, m, size) {
      if (url) out.push({ url: url, type: type, media: m, size: size });
    }
    if (media) {
      push(attr(el, "data-xg-film-webm-narrow"), "video/webm", media, narrow);
      push(attr(el, "data-xg-film-mp4-narrow"), "video/mp4", media, narrow);
    }
    push(attr(el, "data-xg-film-webm"), "video/webm", null, null);
    push(attr(el, "data-xg-film-mp4"), "video/mp4", null, null);
    return out;
  }
  function arm(el) {
    if (el.firstElementChild) return;
    var list = candidates(el);
    if (!list.length) return;
    for (var i = 0; i < list.length; i += 1) {
      var c = list[i];
      var s = doc.createElement("source");
      s.src = c.url;
      s.type = c.type;
      if (c.media) s.media = c.media;
      if (c.size) {
        var wh = c.size.split("x");
        if (wh.length === 2) {
          s.setAttribute("width", wh[0]);
          s.setAttribute("height", wh[1]);
        }
      }
      el.appendChild(s);
    }
    el.load();
  }
  function once(el) {
    return el.hasAttribute("data-xg-film-once");
  }
  function drawing(el) {
    return el.hasAttribute("data-xg-film-img");
  }
  function paint(el) {
    if (el.__xgDrawing) return;
    var url = attr(el, "data-xg-film-img");
    if (!url) return;
    var img = doc.createElement("img");
    img.className = "xg-media__film";
    var size = attr(el, "data-xg-film-img-size");
    var wide = null;
    if (size) {
      var wh = size.split("x");
      if (wh.length === 2) {
        img.setAttribute("width", wh[0]);
        img.setAttribute("height", wh[1]);
        wide = wh[0];
      }
    }
    var poster = el.querySelector("img:not(.xg-media__film)");
    if (wide) img.setAttribute("srcset", url + " " + wide + "w");
    if (poster && poster.getAttribute("sizes")) {
      img.setAttribute("sizes", poster.getAttribute("sizes"));
    }
    img.alt = "";
    img.setAttribute("aria-hidden", "true");
    img.setAttribute("decoding", "async");
    img.setAttribute("loading", "lazy");
    img.addEventListener("load", function () {
      img.setAttribute(STATE, "playing");
    });
    img.addEventListener("error", function () {
      img.remove();
      el.__xgDrawing = null;
    });
    img.src = url;
    el.insertBefore(img, el.querySelector(".xg-media__scrim"));
    el.__xgDrawing = img;
  }
  function unpaint(el) {
    if (!el.__xgDrawing) return;
    el.__xgDrawing.remove();
    el.__xgDrawing = null;
  }
  function play(el) {
    if (drawing(el)) {
      paint(el);
      return;
    }
    arm(el);
    if (!el.firstElementChild) return;
    if (once(el) && el.currentTime > 0) {
      try { el.currentTime = 0; } catch (e) {   }
    }
    var p = el.play();
    if (p && typeof p.catch === "function") {
      p.catch(function () {
        el.setAttribute(STATE, "still");
      });
    }
  }
  function stop(el) {
    if (drawing(el)) return;
    if (!el.firstElementChild) return;
    el.pause();
  }
  function watch(el) {
    if (typeof window.IntersectionObserver !== "function") {
      play(el);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i += 1) {
          if (entries[i].isIntersecting) play(entries[i].target);
          else stop(entries[i].target);
        }
      },
      { rootMargin: "200px 0px", threshold: 0 }
    );
    io.observe(el);
    el.__xgFilmObserver = io;
  }
  function init(root) {
    var scope = root && root.querySelectorAll ? root : doc;
    var nodes = scope.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i += 1) {
      var el = nodes[i];
      if (el.hasAttribute(STATE)) continue;
      if (reduced() || thrifty()) {
        el.setAttribute(STATE, "still");
        continue;
      }
      el.setAttribute(STATE, "armed");
      if (drawing(el)) {
        watch(el);
        continue;
      }
      el.addEventListener("playing", function (e) {
        e.currentTarget.setAttribute(STATE, "playing");
      });
      el.addEventListener("error", function (e) {
        e.currentTarget.setAttribute(STATE, "still");
      }, true);
      watch(el);
    }
  }
  var m = mq();
  if (m) {
    var onChange = function () {
      if (!m.matches) return;
      var all = doc.querySelectorAll(SEL);
      for (var i = 0; i < all.length; i += 1) {
        unpaint(all[i]);
        stop(all[i]);
        all[i].setAttribute(STATE, "still");
      }
    };
    if (m.addEventListener) m.addEventListener("change", onChange);
    else if (m.addListener) m.addListener(onChange);
  }
  var CEILING_MS = 3000;
  function heldBy() {
    var out = [];
    function add(img) {
      if (img && out.indexOf(img) === -1) out.push(img);
    }
    var hi = doc.querySelectorAll('img[fetchpriority="high"]');
    for (var i = 0; i < hi.length; i += 1) add(hi[i]);
    var hosts = doc.querySelectorAll(SEL);
    for (var j = 0; j < hosts.length; j += 1) {
      var frame = drawing(hosts[j]) ? hosts[j] : hosts[j].parentNode;
      var still = frame && frame.querySelector
        ? frame.querySelector("img:not(.xg-media__film)")
        : null;
      if (still && still.getAttribute("loading") !== "lazy") add(still);
    }
    return out;
  }
  function settled(img, fn) {
    function decoded() {
      if (typeof img.decode === "function") img.decode().then(fn, fn);
      else fn();
    }
    if (img.complete) {
      if (img.naturalWidth) decoded();
      else fn();
      return;
    }
    img.addEventListener("load", decoded, { once: true });
    img.addEventListener("error", fn, { once: true });
  }
  function whenIdle(fn) {
    if (doc.readyState === "complete") {
      fn();
      return;
    }
    var done = false;
    function go() {
      if (done) return;
      done = true;
      fn();
    }
    window.addEventListener("load", go, { once: true });
    if (doc.readyState === "loading") {
      doc.addEventListener("DOMContentLoaded", function () {
        window.setTimeout(go, CEILING_MS);
      }, { once: true });
    } else {
      window.setTimeout(go, CEILING_MS);
    }
    var list = heldBy();
    var left = list.length;
    if (!left) {
      go();
      return;
    }
    for (var i = 0; i < list.length; i += 1) {
      settled(list[i], function () {
        left -= 1;
        if (left <= 0) go();
      });
    }
  }
  whenIdle(function () {
    init(doc);
  });
  doc.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
  window.XG = window.XG || {};
  window.XG.film = { init: init };
})();
